import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@ag-common-lib/public-api';
import { getFullAddress } from '../utils/full-address';

@Pipe({ name: 'googleMapsLink' })
export class GoogleMapsLinkPipe implements PipeTransform {
  transform(address: Address): string {
    if (!address) {
      return '';
    }

    const parts = [address.address1, address.address2, address.city, address.state, address.zip, address.country]
      .filter(Boolean) // Remove empty values
      .join(', '); // Format as a comma-separated string

    const encodedAddress = encodeURIComponent(parts); // URL encode for Google Maps
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  }
}
